// extracted by mini-css-extract-plugin
module.exports = {"premiumInput":"PremiumInput__premiumInput__rtlgS","inner":"PremiumInput__inner__k1FGY","hidden":"PremiumInput__hidden__0cnIZ","icon":"PremiumInput__icon__AOcFN"};